import { Fragment } from "react";
import SecondaryButton from "./common/secondary-btn";

export default  function IntegrateSer({toggleModal, id})
{

const title ="Hardware Integration";
const subs="Our expertise in Stripe extends to hardware solutions, enabling seamless and secure payment processing for your physical devices. We ensure that your hardware can effortlessly handle transactions, providing a reliable and efficient payment experience for your customers.";

const devices = [

{
    title:'Stripe Reader S700',
    desc:'Premium Android-based smart reader that can run on your custom POS',
    bg:['https://glocify.com/images/ibg1.png','#B136C6','#B136C64D'],
      logo:'https://glocify.com/images/stripew.svg'
},
{
    title:'Stripe Reader M2',
    desc:'Compact mobile reader that pairs with your POS device',
    bg:['https://glocify.com/images/ibg2.png','#0864EF','#0864EF4D'],
      logo:'https://glocify.com/images/stripew.svg'
},
{
    title:'BBPOS WisePOS E',
    desc:'Smart reader that pairs with your POS device',
    bg:['https://glocify.com/images/ibg3.png','#F05C2D','#F05C2D4D'],
      logo:'https://glocify.com/images/stripew.svg'
},
{
    title:'BBPOS WisePad 3',
    desc:'Compact mobile reader with PIN pad that pairs with your POS device',
    bg:['https://glocify.com/images/ibg4.png','#3833A1','#4C48AC4D'],
    logo:'https://glocify.com/images/stripew.svg'
}

]

return(
        <Fragment><div id={id}></div>
            <hr className="mt-[20px]" ></hr>
        <section className="section-1 py-[60px]" >
            <div className="container mx-auto xl:px-0 lg:px-8 md:px-6 px-4">
                <div className="text-center">
                <h1 className='lg:text-[55px]  text-[35px]  mb-0 font-bold text-[#262626] relative inline-block'>{title} <span className=" rounded-[20px] w-[80px] m-auto h-[5px] bg-[#FB802C] block"></span></h1>
                <p className="text-center text-[#262626] text-[16px] font-regular pt-[20px] max-w-[720px] mx-auto">{subs}</p>
                 </div>
                <ul className="p-0 mx-auto  mt-[60px] mb-[80px] flex lg:flex-nowrap flex-wrap lg:justify-between justify-center lg:gap-0 gap-[20px]">
    {devices.map((item,index)=>(
        <li key={index} style={{background: `linear-gradient(45deg, white, ${item.bg[2]}), url(${item.bg[0]})`,
        backgroundBlendMode: 'color-burn',  backgroundPosition: 'right',  backgroundSize: 'cover', backgroundRepeat: 'no-repeat',}} className=" overflow-hidden lg:w-[23%]  w-[90%] md:w-[45%] rounded-[32px] p-[20px] shadow " data-aos="fade-up"   data-aos-offset='150'  data-aos-duration={(index + 1) * 350}>
            <div className="" style={{color:item.bg[1]}}>
                <span style={{background:item.bg[1]}} className=" h-[26px] w-[65px] rounded-[50px] inline-flex align-center justify-center align-center"><img src={item.logo} alt="stripe" className="max-w-[40px]"/></span>
                <h2 className='lg:text-[28px] md:text-[24px]  text-[24px] font-bold text-left pr-[30px] leading-tight mt-4'>{item.title} </h2>
                <p className="text-left   text-[14px] font-medium pt-[10px] min-h-[100px]">{item.desc}</p>
            </div>
        </li>
    ))}    
</ul>
<div  className="mt-[50px] text-center"> <SecondaryButton  title="Talk to an Expert"  toggleModal={toggleModal}/></div>      
            </div>

        </section>
        </Fragment>

)

}

